"use client";
import {
  useGroup
} from "./UYO2XHHT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./L4OUMOCQ.js";

// src/composite/composite-group.tsx
var TagName = "div";
var useCompositeGroup = createHook(
  function useCompositeGroup2({ store, ...props }) {
    props = useGroup(props);
    return props;
  }
);
var CompositeGroup = forwardRef(function CompositeGroup2(props) {
  const htmlProps = useCompositeGroup(props);
  return createElement(TagName, htmlProps);
});

export {
  useCompositeGroup,
  CompositeGroup
};
